import { render, staticRenderFns } from "./declarations.vue?vue&type=template&id=d4951600&scoped=true"
import script from "./declarations.vue?vue&type=script&lang=js"
export * from "./declarations.vue?vue&type=script&lang=js"
import style0 from "./declarations.vue?vue&type=style&index=0&id=d4951600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4951600",
  null
  
)

export default component.exports